import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

// Ako imaš slike, uvezi ih ovako:
import socerPlayerIcon from "../../Assets/Icons/soccer-player.png";
import championshipIcon from "../../Assets/Icons/championship.png";
import homeIcon from "../../Assets/Icons/home.png";

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { turnirSlug } = useParams(); // Dohvaća slug direktno iz URL rute (npr. "mnt-podsused")

  // Ako postoji turnirSlug, putanje se grade točno za taj turnir
  const homePath = turnirSlug ? `/${turnirSlug}` : "/";
  const championshipPath = turnirSlug
    ? `/${turnirSlug}/zavrsnica`
    : "/zavrsnica";
  const scorersPath = turnirSlug ? `/${turnirSlug}/strijelci` : "/strijelci";

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleNavigate = (path) => {
    navigate(path);
    scrollToTop();
  };

  return (
    <nav className="bottom-nav">
      {/* Naslovna */}
      <div
        className={`nav-item ${location.pathname === homePath ? "active" : ""}`}
        onClick={() => handleNavigate(homePath)}
      >
        <img src={homeIcon} alt="Naslovna" />
        <span>Naslovna</span>
      </div>

      {/* Završnica */}
      <div
        className={`nav-item ${location.pathname === championshipPath ? "active" : ""}`}
        onClick={() => handleNavigate(championshipPath)}
      >
        <img src={championshipIcon} alt="Završnica" />
        <span>Završnica</span>
      </div>

      {/* Strijelci */}
      <div
        className={`nav-item ${location.pathname === scorersPath ? "active" : ""}`}
        onClick={() => handleNavigate(scorersPath)}
      >
        <img src={socerPlayerIcon} alt="Strijelci" />
        <span>Strijelci</span>
      </div>
    </nav>
  );
};

export default BottomNavigation;
